import { TFunction } from "i18next";
import chooseRightCar4 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/elevated-front-view-angle.png";
import chooseRightCar1 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/good-image.png";
import chooseRightCar3 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/unrealistic-car.png";
import chooseRightCar2 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/windows-are-not-transparent.png";

import positionTheCar3 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/too-large-in-frame.png";
import positionTheCar2 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/too-small-in-frame.png";
import positionTheCar1 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/well-positioned-car.png";

import generateReflection1 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/generate-reflection1.png";
import generateReflection2 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/generate-reflection2.png";

import wheelsRefinement1 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/wheels-refinement1.png";
import wheelsRefinement2 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/wheels-refinement2.png";

import generateEffects1 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/generate-effects1.png";
import generateEffects2 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/generate-effects2.png";

import generateHarmonization1 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/generate-harmonization1.png";
import generateHarmonization2 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/generate-harmonization2.png";

import modifyObjectsRemove1 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/modify-objects-remove1.png";
import modifyObjectsRemove2 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/modify-objects-remove2.png";

import modifyObjectsAdd1 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/modify-objects-add1.png";
import modifyObjectsAdd2 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/modify-objects-add2.png";

import expandAspectRatio1 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/expand-aspect-ratio1.png";
import expandAspectRatio2 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/expand-aspect-ratio2.png";

import additionalNotes1 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/additional-notes1.png";
import additionalNotes2 from "../../../../../../../assets/images/pngs/Automotive/BestPractices/additional-notes2.png";

export const getBestPracticesData = (t: TFunction) => {
	return {
		prepareYourImage: [
			{
				title: t("prepareYourImageSection.useCases.chooseRightCarImage.title"),
				description: t("prepareYourImageSection.useCases.chooseRightCarImage.desc"),
				imagesPosition: "bottom",
				images: [chooseRightCar1, chooseRightCar2, chooseRightCar3, chooseRightCar4],
			},
			{
				title: t("prepareYourImageSection.useCases.positionTheCar.title"),
				description: t("prepareYourImageSection.useCases.positionTheCar.desc"),
				images: [positionTheCar1, positionTheCar2, positionTheCar3],
			},
		],
		addEnhancements: [
			{
				id: "generateReflections",
				title: t("addEnhancementsSection.useCases.generateReflections.title"),
				list: [
					{
						text: t("addEnhancementsSection.useCases.generateReflections.listItems.item1"),
					},
					{
						text: t("addEnhancementsSection.useCases.generateReflections.listItems.item2"),
					},
				],
				images: [generateReflection1, generateReflection2],
			},
			{
				id: "wheelsRefinement",
				title: t("addEnhancementsSection.useCases.wheelsRefinement.title"),
				list: [
					{
						text: t("addEnhancementsSection.useCases.wheelsRefinement.listItems.item1"),
					},
					{
						text: t("addEnhancementsSection.useCases.wheelsRefinement.listItems.item2"),
					},
				],
				images: [wheelsRefinement1, wheelsRefinement2],
			},
			{
				id: "generateEffects",
				title: t("addEnhancementsSection.useCases.generateEffects.title"),
				list: [
					{
						text: t("addEnhancementsSection.useCases.generateEffects.listItems.item1"),
					},
					{
						text: t("addEnhancementsSection.useCases.generateEffects.listItems.item2"),
					},
				],
				images: [generateEffects1, generateEffects2],
			},
			{
				id: "generateHarmonization",
				title: t("addEnhancementsSection.useCases.generateHarmonization.title"),
				list: [
					{
						text: t("addEnhancementsSection.useCases.generateHarmonization.listItems.item1"),
					},
					{
						text: t("addEnhancementsSection.useCases.generateHarmonization.listItems.item2"),
					},
				],
				images: [generateHarmonization1, generateHarmonization2],
			},
			{
				id: "modifyObjectsRemove",
				title: t("addEnhancementsSection.useCases.modifyObjectsRemove.title"),
				list: [
					{
						text: t("addEnhancementsSection.useCases.modifyObjectsRemove.listItems.item1"),
					},
				],
				images: [modifyObjectsRemove1, modifyObjectsRemove2],
				hideDivider: true,
			},
			{
				title: t("addEnhancementsSection.useCases.modifyObjectsAddReplace.title"),
				list: [
					{
						text: t("addEnhancementsSection.useCases.modifyObjectsAddReplace.listItems.item1"),
					},
				],
				images: [modifyObjectsAdd1, modifyObjectsAdd2],
			},
			{
				id: "expandAspectRatio",
				title: t("addEnhancementsSection.useCases.expandAspectRatio.title"),
				description: t("addEnhancementsSection.useCases.expandAspectRatio.desc"),
				images: [expandAspectRatio1, expandAspectRatio2],
			},
			{
				id: "additionalNotes",
				title: t("addEnhancementsSection.useCases.additionalNotes.title"),
				description: t("addEnhancementsSection.useCases.additionalNotes.desc"),
				images: [additionalNotes1, additionalNotes2],
			},
		],
	};
};
